import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MassiveLoadEntityType, MassiveLoadError } from '../model/massive-load.model';

function spanishPaginatorIntl(): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.itemsPerPageLabel = 'Registros por página:';
  paginatorIntl.firstPageLabel = 'Primera página';
  paginatorIntl.lastPageLabel = 'Última página';
  paginatorIntl.nextPageLabel = 'Página siguiente';
  paginatorIntl.previousPageLabel = 'Página anterior';
  paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `Mostrando 0 de ${length} entradas`;
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `Mostrando ${startIndex + 1} a ${endIndex} de ${length} entradas`;
  };
  return paginatorIntl;
}

@Component({
  selector: 'app-massive-load-errors',
  standalone: true,
  imports: [MatPaginatorModule],
  providers: [{ provide: MatPaginatorIntl, useFactory: spanishPaginatorIntl }],
  templateUrl: './massive-load-errors.component.html',
  styleUrl: './massive-load-errors.component.css'
})
export class MassiveLoadErrorsComponent implements OnChanges {
  @Input() errors: MassiveLoadError[] = [];
  @Input() totalErrors = 0;
  @Input() entityType: MassiveLoadEntityType = 'PRODUCT';

  pageIndex = 0;
  pageSize = 25;

  get visibleErrors(): MassiveLoadError[] {
    const start = this.pageIndex * this.pageSize;
    return this.errors.slice(start, start + this.pageSize);
  }

  get entityLabel(): string {
    return this.entityType === 'ITEM' ? 'Ítems' : 'Productos';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['errors']) {
      this.pageIndex = 0;
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }
}
